var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEditProfileHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "34px",
    viewBox: "0 0 36 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEditProfileHeader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final-Home-with-submenu",
    transform: "translate(-1187.000000, -108.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(1079.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top",
    transform: "translate(16.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(67.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AccountProfile",
    transform: "translate(25.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9465185,32.9614791 C14.9465185,32.9614791 6.95692498,33.9460208 0,25.9602934 C0,25.9602934 7.44608377,21.4751588 10.4353875,21.4751588 L8.42440134,16.4430566 C8.42440134,16.4430566 5.43509764,12.4501929 7.44608377,10.4264127 C7.44608377,10.4264127 6.46776619,5.39431046 7.44608377,3.42522698 C7.44608377,3.42522698 13.4246912,-3.57595871 21.3599337,2.44068524 C21.3599337,2.44068524 23.3709199,4.46446548 22.3382513,9.44187093 C22.3382513,9.44187093 24.3492374,13.4347346 21.3599337,15.4585149 L19.3489476,21.4751588 L22.3382513,23.4989391 L15.3813263,29.515583 L14.9465185,32.9614791 Z M18,30.8999796 L32.8713405,16.4144297 C32.8713405,16.4144297 36.8190054,14.3289614 35.8456086,19.5144501 L20.9742681,34 L18,34 L18,30.8999796 Z",
    id: "icEditProfileHeader"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditProfileHeader);
export default __webpack_public_path__ + "static/media/icEditProfileHeader.b5763c16a05cbe2a8b3311e1f7cf01db.svg";
export { ForwardRef as ReactComponent };